// extracted by mini-css-extract-plugin
export default {"menuButton":"MobileMenu_menuButton--_Vo","titleOpen":"MobileMenu_titleOpen--s_b","wrapper":"MobileMenu_wrapper--jha","icon":"MobileMenu_icon--ywi","body":"MobileMenu_body--wxc"};